export default "__VITE_ASSET__BEAmoGeo__"